import {
  type CustomerFragmentFragment,
  type ProductFragmentFragment,
} from '@data/shopify/storefront/types'
import { type UserProduct } from '@lib/user/types'
import { parseShopifyGlobalId } from './helpers'

// Delay after which new Shopify products should have their images setup
export const shopifyNewProductDelay = 3000

/**
 * Parses Shopify customer product.
 */
const parseShopifyProduct = (product?: ProductFragmentFragment) => {
  if (!product) {
    return
  }

  const id = parseShopifyGlobalId(product.id)

  if (!id) {
    return
  }

  const userProduct: UserProduct = {
    id,
    title: product.title,
    slug: product.handle,
  }

  return userProduct
}

/**
 * Gets user products from Shopify customer with products.
 */
export const getUserProducts = (shopifyCustomer?: CustomerFragmentFragment) => {
  const orders = shopifyCustomer?.orders?.edges?.map((edge) => edge.node)
  const lineItems = orders?.flatMap((order) =>
    order.lineItems.edges.map((edge) => edge.node),
  )
  const userProducts =
    lineItems
      ?.map((lineItem) => parseShopifyProduct(lineItem.variant?.product))
      ?.filter(Boolean) ?? []

  return userProducts as UserProduct[]
}
